import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { SlidersHorizontal } from "lucide-react";

const ROWS = [
  ["sem_giorni_valutazione", "Giorni senza valutazione → rosso", "giorni"],
  ["sem_esiti", "N. esiti mancanti → rosso", ""],
  ["sem_doc_giorni", "Giorni documenti mancanti → giallo", "giorni"],
  ["soglia_sconto_direttore", "Soglia sconto che approva il direttore", "%"],
  ["provv_standard_venditore_pct", "Provvigione standard agenzia — venditore", "%"],
  ["provv_standard_acquirente_pct", "Provvigione standard agenzia — acquirente", "%"],
];

export default function SemaforoConfigCard() {
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/fase3b").then((r) => setC(r.data)).catch(() => setC(null)); }, []);
  if (!c) return null;
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/settings/fase3b", c); setC(r.data); toast.success("Soglie salvate"); }
    catch { toast.error("Errore nel salvataggio"); } finally { setSaving(false); }
  };
  return (
    <div className="card-immo p-5" data-testid="semaforo-config-card">
      <div className="flex items-center gap-2 mb-1"><span className="w-8 h-8 rounded-xl bg-[#FC82ED]/15 text-[#FC82ED] flex items-center justify-center"><SlidersHorizontal size={16} /></span><h2 className="font-display font-bold text-base">Soglie semaforo & approvazioni</h2></div>
      <p className="text-xs text-[var(--muted)] mb-4">Regole del semaforo del team e soglia sconto provvigione (default: 10 / 1 / 7 giorni / 0,5% · provvigione standard 3% + 3%).</p>
      <div className="space-y-3">
        {ROWS.map(([k, label, suf]) => (
          <div key={k} className="flex items-center justify-between gap-3">
            <label className="text-sm flex-1">{label}</label>
            <div className="flex items-center gap-1.5">
              <input data-testid={`cfg-${k}`} type="number" step={k === "soglia_sconto_direttore" ? "0.1" : "1"} value={c[k]}
                onChange={(e) => setC({ ...c, [k]: e.target.value })}
                className="w-20 px-2.5 py-2 rounded-lg border border-[var(--border)] text-sm text-right" />
              {suf && <span className="text-xs text-[var(--muted)] w-10">{suf}</span>}
            </div>
          </div>
        ))}
      </div>
      <button data-testid="cfg-salva" onClick={save} disabled={saving} className="w-full mt-4 py-2.5 rounded-xl bg-[#111111] text-white font-semibold text-sm disabled:opacity-50">{saving ? "Salvo…" : "Salva soglie"}</button>
    </div>
  );
}
